import React from 'react';
import AppNav from '../components/app/AppNav';
import AboutSection from '../components/AboutSection';
import ScreenshotsSection from '../components/ScreenshotsSection';
import Features from './Features';

export default function KnowMore() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7f7f7' }}>
      <AppNav />
      <div style={{ paddingTop: '64px' }}>
        <div style={{ textAlign: 'center', padding: '3rem 1.5rem 1rem', background: 'white' }}>
          <p style={{ color: '#6366f1', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.5rem' }}>Know More</p>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#111827', margin: 0 }}>Everything about Sahayy</h1>
          <p style={{ color: '#6b7280', marginTop: '0.75rem', fontSize: '1rem' }}>Our story, features and a peek at the app.</p>
        </div>
        <AboutSection />
        <Features isHomePage={false} />
        <ScreenshotsSection />
      </div>
    </div>
  );
}
